import React from 'react';
import LeftControl from "./LeftControl";
import TopControl from "./TopControl";
import RightControl from "./RightControl";
import styles from '../style.module.scss';
import {EL_DASHBOARD} from "./constants";
import {ACTION} from "../../../util/varibles/permission";
import {useSelector} from "react-redux";
import {selectPermissions} from "../../../util/store/selectors";

const Control: React.FC = () => {
    const [canViewLeftControl, canViewTopControl, canViewRightControl] = useSelector(selectPermissions([
        ACTION.DASHBOARD.LEFT_CONTROL,
        ACTION.DASHBOARD.TOP_CONTROL,
        ACTION.DASHBOARD.RIGHT_CONTROL,
    ]));

    return <div id={EL_DASHBOARD.CONTROL} className={styles.control}>
        {canViewLeftControl && <LeftControl/>}
        {canViewTopControl && <TopControl/>}
        {canViewRightControl && <RightControl/>}
    </div>;
};

export default Control;
